
export const technicalProperties_fieldData_installation =
{
  "idShort": "Installation_1",
  "displayName": [
    {
      "language": "en",
      "text": "Installation 1"
    },
    {
      "language": "de",
      "text": "Einbau 1"
    }
  ],
  "semanticId": {
    "type": "ExternalReference",
    "keys": [
      {
        "type": "GlobalReference",
        "value": "https://admin-shell.io/ZVEI/TechnicalData/SubSection/1/1"
      }
    ]
  },
  "value": [
    {
      "idShort": "BatteryVoltage",
      "displayName": [
        {
          "language": "en",
          "text": "Battery Voltage (V)"
        },
        {
          "language": "de",
          "text": "Batteriespannung (V)"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "https://admin-shell.io/SemanticIdNotAvailable/1/1"
          }
        ]
      },
      "value": "",
      "valueType": "xs:double",
      "modelType": "Property"
    },
    {
      "idShort": "MeterReading",
      "displayName": [
        {
          "language": "en",
          "text": "Meter Reading (m³)"
        },
        {
          "language": "de",
          "text": "Z\u00E4hlerstand (m³)"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "https://admin-shell.io/SemanticIdNotAvailable/1/1"
          }
        ]
      },
      "value": "",
      "valueType": "xs:double",
      "modelType": "Property"
    },
    {
      "idShort": "Date",
      "displayName": [
        {
          "language": "en",
          "text": "Date"
        },
        {
          "language": "de",
          "text": "Datum"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "https://admin-shell.io/SemanticIdNotAvailable/1/1"
          }
        ]
      },
      "value": "",
      "valueType": "xs:dateTime",
      "modelType": "Property"
    }
  ],
  "modelType": "SubmodelElementCollection"
};


export const technicalProperties_fieldData_removal =
{
  "idShort": "Removal_1",
  "displayName": [
    {
      "language": "en",
      "text": "Removal_1"
    },
    {
      "language": "de",
      "text": "Ausbau_1"
    }
  ],
  "semanticId": {
    "type": "ExternalReference",
    "keys": [
      {
        "type": "GlobalReference",
        "value": "https://admin-shell.io/ZVEI/TechnicalData/SubSection/1/1"
      }
    ]
  },
  "value": [
    {
      "idShort": "BatteryVoltage",
      "displayName": [
        {
          "language": "en",
          "text": "Battery Voltage (V)"
        },
        {
          "language": "de",
          "text": "Batteriespannung (V)"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "https://admin-shell.io/SemanticIdNotAvailable/1/1"
          }
        ]
      },
      "value": "",
      "valueType": "xs:double",
      "modelType": "Property"
    },
    {
      "idShort": "MeterReading",
      "displayName": [
        {
          "language": "en",
          "text": "Meter Reading (m³)"
        },
        {
          "language": "de",
          "text": "Z\u00E4hlerstand (m³)"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "https://admin-shell.io/SemanticIdNotAvailable/1/1"
          }
        ]
      },
      "value": "",
      "valueType": "xs:double",
      "modelType": "Property"
    },
    {
      "idShort": "Date",
      "displayName": [
        {
          "language": "en",
          "text": "Date"
        },
        {
          "language": "de",
          "text": "Datum"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "https://admin-shell.io/SemanticIdNotAvailable/1/1"
          }
        ]
      },
      "value": "",
      "valueType": "xs:dateTime",
      "modelType": "Property"
    }
  ],
  "modelType": "SubmodelElementCollection"
};